import { createSlice, createAsyncThunk  } from "@reduxjs/toolkit";
import { getIndividual } from "sr/utils/api/individual/getIndividual";

export const fetchIndividual =  createAsyncThunk('fetchIndividual', async (params:any)=>{
try {
    const queryParams = new URLSearchParams();
    if (params?.id) queryParams.append('id', params?.id)

const res = await getIndividual(queryParams)
if(res?.success===true){
    return res.data
}
}
catch(e){

}
})
interface IndividualState {
    loader:boolean,
    data:any,
    isError:boolean
}
const initialState:IndividualState = {
    loader:false,
    isError:false,
    data:null
}
const IndividualSlice = createSlice({
    name:'Individual',
    initialState,
    extraReducers:(builder)=>{
            builder.addCase(fetchIndividual.pending, (state, action)=>{
                state.loader = true
            })
            builder.addCase(fetchIndividual.rejected, (state, action)=>{
                state.isError = true
            })
            builder.addCase(fetchIndividual.fulfilled, (state, action)=> {
                state.data = action.payload
            })
    },
    reducers:undefined
})
export default IndividualSlice.reducer;